const state = {
    projectName: '',
    links: [],
    interests: [],
    projectId: null,
    isLoading: false,  // Состояние для отслеживания загрузки
    projectLoaded: false,  // Флаг для отслеживания, был ли загружен проект
};

const mutations = {
    SET_PROJECT_NAME(state, name) {
        state.projectName = name;
    },
    SET_LINKS(state, links) {
        state.links = links;
    },
    SET_INTERESTS(state, interests) {
        state.interests = interests;
    },
    SET_PROJECT_ID(state, id) {
        state.projectId = id;
    },
    SET_PROJECT(state, project) {  // Мутация для обновления данных проекта
        state.projectName = project.name || '';
        state.links = project.links || [];
        state.interests = project.interests || [];
        state.projectId = project.id || null;
        state.projectLoaded = true; // Устанавливаем флаг, что проект загружен
    },
    RESET_PROJECT(state) { // Сброс данных проекта
        state.projectName = '';
        state.links = [];
        state.interests = [];
        state.projectId = null;
        state.projectLoaded = false;
    },
    SET_LOADING(state, isLoading) {  // Мутация для изменения состояния загрузки
        state.isLoading = isLoading;
    }
};

const actions = {
    // Действия для изменения состояния
    setProjectName({ commit }, name) {
        commit('SET_PROJECT_NAME', name);
    },
    setLinks({ commit }, links) {
        commit('SET_LINKS', links);
    },
    setInterests({ commit }, interests) {
        commit('SET_INTERESTS', interests);
    },
    setProjectId({ commit }, id) {
        commit('SET_PROJECT_ID', id);
    },

    // Действие для получения проекта (с проверкой, был ли проект уже загружен)
    async fetchProject({ commit, state }, { apiKey, router, message }) {
        if (state.projectLoaded) return;  // Если проект уже загружен, не запрашиваем его снова
        try {
            commit('SET_LOADING', true); // Устанавливаем флаг загрузки
            const response = await axios.get(`/api/admin/pump-projects/data/${apiKey}`);
            const project = response.data.project; // Структура данных зависит от ответа API
            commit('SET_PROJECT', project);  // Обновляем данные проекта
        } catch (error) {

            message({
                type: "error",
                message: "Проект не найден или у вас нет доступа к этому проекту!"
            });

            if (router) {
                router.push({ name: 'pump-projects-list' });  // Используем переданный роутер для перехода
            }
            console.error("Ошибка загрузки проекта:", error);
        } finally {
            commit('SET_LOADING', false); // Останавливаем индикатор загрузки
        }
    },
};

const getters = {
    getProjectName: (state) => state.projectName,
    links: (state) => state.links,
    interests: (state) => state.interests,
    getProjectId: (state) => state.projectId,
    isLoading: (state) => state.isLoading,
    project: (state) => ({
        name: state.projectName,
        id: state.projectId,
        links: state.links,
        interests: state.interests,
    }),
    projectLoaded: (state) => state.projectLoaded,  // Геттер для флага загрузки проекта
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
